import { useMutation, useQueryClient } from "@tanstack/react-query";

import { banUser, unbanUser } from "@/api/users";
import { SubDealersQueryKeys } from "@/tanstackQuery/queries";

export const useBanUser = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: banUser,
    onSuccess() {
      queryClient.invalidateQueries({
        queryKey: [SubDealersQueryKeys.Players],
      });
    },
  });
};

export const useUnbanUser = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: unbanUser,
    onSuccess() {
      queryClient.invalidateQueries({
        queryKey: [SubDealersQueryKeys.Players],
      });
    },
  });
};
